import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../redux/hooks";
import ordersService from "../../api/services/ordersService";
import StickerItem from "./StickerItem";
import {Button} from "../buttons";
import {t} from "i18next";
import b64toBlob from "../../utils/FileHelper";


export interface Stickers {
    file: string,
    skus: any,
    productIds: string,
    uuid: string,
    counter: any
}

const StickersList: any = () => {

    const [stickerList, setStickerList] = useState<Stickers[]>([]);
    const stickerOrderId = useAppSelector((state) => state.orders.stickerOrderId);


    useEffect(() => {
        if(!stickerOrderId){
            setStickerList([]);
            return;
        }

        ordersService.getStickersByOrderID(stickerOrderId).then(
            (res) => {
                if (res.data.success) {
                    const resData = res.data.data
                    // @ts-ignore
                    setStickerList(resData)
                } else {
                    setStickerList([]);
                }
            },
            (err) => {
                alert('Failed getting stickers: ' + err.message)
            }
        )
            .catch((err) => {
                alert('Failed getting stickers: ' + err.message)
            })
        ;
    }, [stickerOrderId])

    function handleClickAllDownload(stickerList: any) {
        stickerList.forEach((v: any) => {

            const blob = b64toBlob(v.file, 'application/pdf');
            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.style.display = 'none';

            a.setAttribute('href', blobUrl);
            a.setAttribute('download', v.skus + '.pdf');
            a.click()

            setTimeout(function() {
                a.remove();
            }, 5000);
        })
    }

    // @ts-ignore
    return (
        <>
            <div className={`flex md:justify-between flex-col md:flex-row items-center`}>
                <div className="mr-4 mb-2 md:mb-0">
                        <div className={`inline-flex min-w-fit md:min-w-80 px-4 py-2 rounded-sm text-sm bg-white border border-gray-200 text-gray-600`}>
                            <div className="flex w-full justify-between items-start">
                                <div className="flex">
                                    <svg className="w-4 h-4 flex-shrink-0 fill-current text-indigo-500 mt-[3px] mr-3"
                                         viewBox="0 0 16 16">
                                        <path
                                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"></path>
                                    </svg>
                                    <div className="text-xs	">
                                        Необходимо браузеру разрешить скачивание нескольких файлов
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <Button
                    appearance="primary"
                    customClassName="button-add btn-sm h-fit"
                    clickHandler={() => handleClickAllDownload(stickerList)}
                >
                    <div className="flex justify-around w-[150px] items-center">
                        <div>Скачать все</div>
                    </div>
                </Button>
            </div>
            {
                (stickerList.length > 0)
                    ?
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full mb-2 mt-4">
                            <thead className="text-xs uppercase text-gray-400">
                            <tr className="">
                                <th className="pr-[20px]">
                                    <div className="font-semibold text-left">Отправление</div>
                                </th>
                                <th className="pr-[20px]">
                                    <div className="font-semibold text-left">Артикулы</div>
                                </th>
                                <th className="">
                                    <div className="font-semibold text-right">Скачать</div>
                                </th>
                            </tr>
                            </thead>
                            <tbody className="text-sm">
                            {stickerList.map((item, key) =>
                                <StickerItem key={key} stickerList={stickerList} setStickerList={setStickerList} item={item} counter={key}
                                ></StickerItem>
                            )
                            }
                            </tbody>
                        </table>
                    </div>
                    :
                    <div className="pt-4 text-center">
                        {t("Missing stickers", { ns: "messages" }) as string}
                    </div>
            }
        </>

    )
}

export default StickersList